<app-select class='app-provider-selection'
            [style]='style'
            [label]='"STATISTICS.SETTINGS.PROVIDER.LABEL" | translate'
            [defaultText]='"STATISTICS.SETTINGS.PROVIDER.DEFAULT" | translate'
            [options]='providerOptions'
            [(value)]='provider'>
</app-select>
